interface IScrollToElementOptions {
  elementId: string
  behavior?: ScrollBehavior
  timeout?: number
}

export const scrollVerticalToElement = async ({
  elementId,
  behavior = 'smooth',
  timeout = 0,
}: IScrollToElementOptions): Promise<boolean> => {
  return new Promise((resolve) => {
    const el = document.getElementById(elementId)

    if (el) {
      setTimeout(() => {
        window.scrollTo({ top: el.offsetTop, behavior })
        resolve(true)
      }, timeout)
    } else {
      resolve(false)
    }
  })
}
